export const SEO_CONFIG = {
  home: {
    title: {
      ar: 'سلاسة | نظام محاسبة وفوترة إلكترونية معتمد في السعودية',
      en: 'Salasah | Certified Electronic Accounting and Invoicing System in Saudi Arabia'
    },
    description: {
      ar: 'سلاسة هو نظام محاسبة وفوترة إلكتروني معتمد من هيئة الزكاة والضريبة والجمارك، مصمم لتلبية احتياجات الشركات والمتاجر في المملكة العربية السعودية. حلول ذكية لإدارة الفواتير والمصروفات.',
      en: 'Salasah is an electronic accounting and invoicing system certified by ZATCA, designed to meet the needs of companies and stores in Saudi Arabia. Smart solutions for invoice and expense management.'
    },
    keywords: {
      ar: 'سلاسة, نظام محاسبة إلكتروني, نظام فوترة إلكتروني, الفاتورة الإلكترونية السعودية, برنامج محاسبة معتمد من الزكاة والدخل, إصدار الفواتير الإلكترونية, أفضل نظام محاسبة للشركات, برنامج محاسبة سهل, إدارة الأعمال السعودية',
      en: 'salasah, electronic accounting system, e-invoicing system, saudi e-invoice, zatca approved accounting, e-invoice generation, best accounting software, simple accounting software, saudi business management'
    }
  },
  workspace: {
    title: {
      ar: 'سلاسة | مساحة العمل الذكية لزيادة الإنتاجية والتعاون',
      en: 'Salasah | Smart Workspace for Increased Productivity and Collaboration'
    },
    description: {
      ar: 'مساحة عمل متطورة تجمع جميع أدوات الإنتاجية في مكان واحد. إدارة المهام، التعاون الفوري، مشاركة الملفات، ولوحات المتابعة التفاعلية لتحسين كفاءة العمل والتواصل بين الفرق.',
      en: 'Advanced workspace that brings all productivity tools together. Task management, real-time collaboration, file sharing, and interactive dashboards to improve work efficiency and team communication.'
    },
    keywords: {
      ar: 'مساحة العمل الذكية, زيادة الإنتاجية, تعاون الفريق, إدارة المهام, مشاركة الملفات, لوحة القيادة, التواصل الفوري, أدوات العمل',
      en: 'smart workspace, productivity increase, team collaboration, task management, file sharing, dashboard, instant communication, work tools'
    }
  },
  financial: {
    title: {
      ar: 'سلاسة | أفضل نظام محاسبة إلكترونية للمنشآت الصغيرة والمتوسطة',
      en: 'Salasah | Best Electronic Accounting System for SMEs'
    },
    description: {
      ar: 'نظام محاسبة وفوترة إلكتروني متكامل معتمد من هيئة الزكاة والضريبة والجمارك. إصدار فواتير إلكترونية ضريبية معتمدة، إدارة المصروفات، التقارير المالية، والربط مع أنظمة الدفع المحلية مثل مدى وSTC Pay.',
      en: 'Integrated electronic accounting and invoicing system certified by ZATCA. Generate certified tax e-invoices, expense management, financial reports, and integration with local payment systems like Mada and STC Pay.'
    },
    keywords: {
      ar: 'نظام محاسبة إلكتروني, نظام فوترة إلكتروني, الفاتورة الإلكترونية السعودية, برنامج محاسبة معتمد, إصدار الفواتير الإلكترونية, ضريبة القيمة المضافة, التقارير المالية, إدارة المصروفات, نظام الخزينة',
      en: 'electronic accounting system, e-invoicing system, saudi e-invoice, approved accounting software, e-invoice generation, VAT, financial reports, expense management, treasury system'
    }
  },
  hr: {
    title: {
      ar: 'سلاسة | نظام إدارة الموارد البشرية الشامل والذكي',
      en: 'Salasah | Comprehensive and Smart Human Resources Management System'
    },
    description: {
      ar: 'نظام شامل لإدارة الموارد البشرية يشمل الرواتب، الحضور والانصراف، إدارة الموظفين، والتقارير التفصيلية. حلول ذكية لتبسيط العمليات الإدارية وتحسين إنتاجية الموظفين في الشركات السعودية.',
      en: 'Comprehensive HR management system including payroll, attendance, employee management, and detailed reports. Smart solutions to simplify administrative processes and improve employee productivity in Saudi companies.'
    },
    keywords: {
      ar: 'إدارة الموارد البشرية, نظام الرواتب, الحضور والانصراف, إدارة الموظفين, التقارير الإدارية, نظام الإجازات, تقييم الأداء, إدارة الموظفين السعودية',
      en: 'human resources management, payroll system, attendance management, employee management, administrative reports, leave management, performance evaluation, saudi employee management'
    }
  },
  manufacturing: {
    title: {
      ar: 'سلاسة | نظام إدارة التصنيع والإنتاج المتقدم',
      en: 'Salasah | Advanced Manufacturing and Production Management System'
    },
    description: {
      ar: 'حلول متطورة لإدارة عمليات التصنيع والإنتاج وسلسلة التوريد. تخطيط الإنتاج، إدارة المخزون، متابعة جودة المنتجات، وتحسين كفاءة العمليات التصنيعية في الشركات السعودية.',
      en: 'Advanced solutions for manufacturing operations, production, and supply chain management. Production planning, inventory management, product quality tracking, and improving manufacturing efficiency in Saudi companies.'
    },
    keywords: {
      ar: 'إدارة التصنيع, نظام الإنتاج, سلسلة التوريد, تخطيط الإنتاج, إدارة المخزون, جودة المنتجات, كفاءة التصنيع, العمليات الصناعية',
      en: 'manufacturing management, production system, supply chain, production planning, inventory management, product quality, manufacturing efficiency, industrial operations'
    }
  },
  crm: {
    title: {
      ar: 'سلاسة | نظام إدارة علاقات العملاء CRM لزيادة المبيعات',
      en: 'Salasah | Customer Relationship Management CRM System to Increase Sales'
    },
    description: {
      ar: 'نظام متطور لإدارة علاقات العملاء يساعدك على زيادة المبيعات، تحسين خدمة العملاء، وبناء علاقات طويلة الأمد. إدارة قاعدة بيانات العملاء، الفرص التجارية، والمتابعة الذكية للعملاء المحتملين.',
      en: 'Advanced customer relationship management system that helps you increase sales, improve customer service, and build long-term relationships. Customer database management, sales opportunities, and smart follow-up for potential customers.'
    },
    keywords: {
      ar: 'إدارة علاقات العملاء, نظام CRM, زيادة المبيعات, خدمة العملاء, قاعدة بيانات العملاء, الفرص التجارية, متابعة العملاء, إدارة المبيعات',
      en: 'customer relationship management, CRM system, sales increase, customer service, customer database, sales opportunities, customer follow-up, sales management'
    }
  },
  projects: {
    title: {
      ar: 'سلاسة | إدارة المشاريع الاحترافية وتتبع التقدم',
      en: 'Salasah | Professional Project Management and Progress Tracking'
    },
    description: {
      ar: 'أدوات قوية لإدارة المشاريع بفعالية. تخطيط المشاريع، توزيع المهام، متابعة التقدم، إدارة الموارد، والتقارير التفصيلية لضمان نجاح المشاريع ووصولها في الوقت المحدد والميزانية المطلوبة.',
      en: 'Powerful tools for effective project management. Project planning, task allocation, progress tracking, resource management, and detailed reports to ensure project success on time and within budget.'
    },
    keywords: {
      ar: 'إدارة المشاريع, تخطيط المشاريع, متابعة التقدم, إدارة المهام, إدارة الموارد, جدولة المشاريع, تقارير المشاريع, إدارة الوقت',
      en: 'project management, project planning, progress tracking, task management, resource management, project scheduling, project reports, time management'
    }
  },
  support: {
    title: {
      ar: 'سلاسة | الدعم الفني المتخصص والمساعدة على مدار الساعة',
      en: 'Salasah | Specialized Technical Support and 24/7 Assistance'
    },
    description: {
      ar: 'فريق دعم فني متخصص لمساعدتك في جميع استفساراتك. دعم على مدار الساعة، حلول سريعة، تدريب شامل على جميع أنظمة سلاسة، وخدمة عملاء متميزة باللغة العربية.',
      en: 'Specialized technical support team to help with all your inquiries. 24/7 support, quick solutions, comprehensive training on all Salasah systems, and excellent customer service in Arabic.'
    },
    keywords: {
      ar: 'الدعم الفني, خدمة العملاء, المساعدة التقنية, التدريب على الأنظمة, الحلول التقنية, دعم باللغة العربية, مساعدة فورية',
      en: 'technical support, customer service, technical assistance, system training, technical solutions, arabic support, instant help'
    }
  },
  sales: {
    title: {
      ar: 'سلاسة | نظام إدارة المبيعات وتحسين الأداء التجاري',
      en: 'Salasah | Sales Management System and Commercial Performance Enhancement'
    },
    description: {
      ar: 'نظام متطور لإدارة المبيعات وتحسين الأداء التجاري. تتبع المبيعات، إدارة العملاء المحتملين، تحليل الأداء، وتقارير مفصلة لزيادة الإيرادات وتحسين استراتيجيات البيع.',
      en: 'Advanced sales management system and commercial performance enhancement. Sales tracking, lead management, performance analysis, and detailed reports to increase revenue and improve sales strategies.'
    },
    keywords: {
      ar: 'إدارة المبيعات, تحسين الأداء التجاري, تتبع المبيعات, العملاء المحتملين, تحليل المبيعات, زيادة الإيرادات, استراتيجيات البيع',
      en: 'sales management, commercial performance enhancement, sales tracking, leads, sales analysis, revenue increase, sales strategies'
    }
  },
  contact: {
    title: {
      ar: 'سلاسة | اتصل بنا للحصول على استشارة مجانية',
      en: 'Salasah | Contact Us for Free Consultation'
    },
    description: {
      ar: 'تواصل معنا للحصول على استشارة مجانية حول احتياجاتك من الحلول الرقمية. فريقنا المتخصص جاهز لمساعدتك في اختيار الأنظمة المناسبة لشركتك وتقديم الدعم اللازم.',
      en: 'Contact us for a free consultation about your digital solution needs. Our specialized team is ready to help you choose the right systems for your company and provide the necessary support.'
    },
    keywords: {
      ar: 'اتصل بنا, استشارة مجانية, الحلول الرقمية, الدعم التقني, خدمة العملاء, تواصل معنا, المساعدة التقنية',
      en: 'contact us, free consultation, digital solutions, technical support, customer service, reach us, technical assistance'
    }
  },
  'kanban-board': {
    title: {
      ar: 'سلاسة | لوحة كانبان لإدارة المهام بصرياً وبكفاءة',
      en: 'Salasah | Kanban Board for Visual and Efficient Task Management'
    },
    description: {
      ar: 'لوحة كانبان تفاعلية لإدارة المهام والمشاريع بصرياً. تنظيم سير العمل، تتبع التقدم، والتعاون الفعال بين أعضاء الفريق لزيادة الإنتاجية وتحسين الأداء.',
      en: 'Interactive Kanban board for visual task and project management. Workflow organization, progress tracking, and effective team collaboration to increase productivity and improve performance.'
    },
    keywords: {
      ar: 'لوحة كانبان, إدارة المهام بصرياً, سير العمل, تتبع التقدم, تعاون الفريق, زيادة الإنتاجية, تنظيم المهام',
      en: 'kanban board, visual task management, workflow, progress tracking, team collaboration, productivity increase, task organization'
    }
  },
  agile: {
    title: {
      ar: 'سلاسة | منهجية الأجايل لتطوير المشاريع بمرونة',
      en: 'Salasah | Agile Methodology for Flexible Project Development'
    },
    description: {
      ar: 'تطبيق منهجية الأجايل في إدارة المشاريع لضمان المرونة والكفاءة. سبرينت، ستاند آب، وأدوات متطورة لإدارة المشاريع الرشيقة وتحسين جودة التسليم.',
      en: 'Agile methodology implementation in project management for flexibility and efficiency. Sprints, stand-ups, and advanced tools for agile project management and improved delivery quality.'
    },
    keywords: {
      ar: 'منهجية الأجايل, المشاريع الرشيقة, سبرينت, ستاند آب, التطوير المرن, إدارة المشاريع, جودة التسليم',
      en: 'agile methodology, agile projects, sprint, stand-up, flexible development, project management, delivery quality'
    }
  },
  email: {
    title: {
      ar: 'سلاسة | إدارة البريد الإلكتروني وأتمتة التواصل',
      en: 'Salasah | Email Management and Communication Automation'
    },
    description: {
      ar: 'نظام متطور لإدارة البريد الإلكتروني وأتمتة التواصل. قوالب احترافية، إرسال جماعي، تتبع الرسائل، وتكامل مع أنظمة الشركة لتحسين كفاءة التواصل.',
      en: 'Advanced email management system and communication automation. Professional templates, bulk sending, message tracking, and integration with company systems to improve communication efficiency.'
    },
    keywords: {
      ar: 'إدارة البريد الإلكتروني, أتمتة التواصل, قوالب البريد, الإرسال الجماعي, تتبع الرسائل, كفاءة التواصل',
      en: 'email management, communication automation, email templates, bulk sending, message tracking, communication efficiency'
    }
  },
  about: {
    title: {
      ar: 'سلاسة | قصة شركة رائدة في الحلول الرقمية السعودية',
      en: 'Salasah | Leading Saudi Digital Solutions Company Story'
    },
    description: {
      ar: 'تعرف على قصة سلاسة، الشركة الرائدة في تقديم الحلول الرقمية في المملكة العربية السعودية. رؤيتنا، رسالتنا، وقيمنا في خدمة الأعمال وتقديم أفضل الحلول التقنية للشركات السعودية.',
      en: 'Learn about Salasah story, the leading digital solutions company in Saudi Arabia. Our vision, mission, and values in serving businesses and providing the best technical solutions for Saudi companies.'
    },
    keywords: {
      ar: 'حول سلاسة, الحلول الرقمية السعودية, رؤية الشركة, قصة النجاح, الشركات الرائدة, التقنية السعودية, القيم والمبادئ',
      en: 'about salasah, saudi digital solutions, company vision, success story, leading companies, saudi technology, values and principles'
    }
  },
  services: {
    title: {
      ar: 'سلاسة | خدمات الحلول الرقمية المتكاملة للأعمال',
      en: 'Salasah | Integrated Digital Business Solutions Services'
    },
    description: {
      ar: 'مجموعة شاملة من الخدمات والحلول الرقمية لتطوير الأعمال. استشارات تقنية، تطوير الأنظمة، التدريب، والدعم الفني المستمر لضمان نجاح شركتك في العصر الرقمي.',
      en: 'Comprehensive range of digital services and solutions for business development. Technical consulting, system development, training, and continuous technical support to ensure your company\'s success in the digital age.'
    },
    keywords: {
      ar: 'خدمات الحلول الرقمية, استشارات تقنية, تطوير الأنظمة, التدريب التقني, الدعم المستمر, تطوير الأعمال, الحلول المتكاملة',
      en: 'digital solutions services, technical consulting, system development, technical training, continuous support, business development, integrated solutions'
    }
  },
  'privacy-policy': {
    title: {
      ar: 'سلاسة | سياسة الخصوصية وحماية البيانات',
      en: 'Salasah | Privacy Policy and Data Protection'
    },
    description: {
      ar: 'سياسة الخصوصية وحماية البيانات في سلاسة. نحن ملتزمون بحماية خصوصيتك وبياناتك الشخصية وفقاً لأعلى معايير الأمان والقوانين السعودية.',
      en: 'Privacy policy and data protection at Salasah. We are committed to protecting your privacy and personal data according to the highest security standards and Saudi laws.'
    },
    keywords: {
      ar: 'سياسة الخصوصية, حماية البيانات, الأمان, الخصوصية, البيانات الشخصية, الحماية, القوانين السعودية',
      en: 'privacy policy, data protection, security, privacy, personal data, protection, saudi laws'
    }
  },
  'terms-of-service': {
    title: {
      ar: 'سلاسة | شروط الخدمة والاستخدام',
      en: 'Salasah | Terms of Service and Use'
    },
    description: {
      ar: 'شروط الخدمة والاستخدام لأنظمة سلاسة. تعرف على حقوقك وواجباتك عند استخدام خدماتنا وأنظمتنا الرقمية.',
      en: 'Terms of service and use for Salasah systems. Learn about your rights and obligations when using our services and digital systems.'
    },
    keywords: {
      ar: 'شروط الخدمة, شروط الاستخدام, الحقوق والواجبات, الخدمات الرقمية, القوانين, الشروط والأحكام',
      en: 'terms of service, terms of use, rights and obligations, digital services, laws, terms and conditions'
    }
  },
  'workspace-view': {
    title: {
      ar: 'سلاسة | عرض مساحة العمل المتقدمة والأدوات التفاعلية',
      en: 'Salasah | Advanced Workspace View and Interactive Tools'
    },
    description: {
      ar: 'عرض شامل لمساحة العمل المتقدمة مع الأدوات التفاعلية. لوحات قيادة ديناميكية، تقارير فورية، وأدوات تحليل متطورة لاتخاذ قرارات مدروسة.',
      en: 'Comprehensive view of the advanced workspace with interactive tools. Dynamic dashboards, instant reports, and advanced analysis tools for informed decision making.'
    },
    keywords: {
      ar: 'عرض مساحة العمل, الأدوات التفاعلية, لوحات القيادة, التقارير الفورية, أدوات التحليل, اتخاذ القرارات',
      en: 'workspace view, interactive tools, dashboards, instant reports, analysis tools, decision making'
    }
  }
} 